const breadCrumb = "Exames - Parametrização de Exames";

const routes = [
  {
    path: "/manutencao-exame-amparo-rede",
    name: "manutencao-exame-amparo-rede",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameAmparoRede/ExameAmparoRedeHome.vue"),
  },
  {
    path: "/manutencao-exame-amparo-rede/novo",
    name: "manutencao-exame-amparo-rede-novo",
    meta: {
      allowedPermissions: ["exame_amparo_create"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameAmparoRede/ExameAmparoRedeCad.vue"),
  },
  {
    path: "/manutencao-exame-amparo-rede/editar/:id",
    name: "manutencao-exame-amparo-rede-editar",
    meta: {
      allowedPermissions: ["exame_amparo_edit"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameAmparoRede/ExameAmparoRedeEdit.vue"),
  },
  {
    path: "/manutencao-exame-amparo-rede/visualizar/:id",
    name: "manutencao-exame-amparo-rede-visualizar",
    meta: {
      allowedPermissions: ["exame_amparo_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ExameAmparoRede/ExameAmparoRedeVisualizar.vue"),
  },
];

export default routes;
